import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { ScheduleOffService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { ScheduleOff } from '../../models'

const log = new Logger('ScheduleOffDetailResolver')
@Injectable({ providedIn: 'root' })
export class ScheduleOffDetailResolver
  implements Resolve<Observable<ScheduleOff>> {
  constructor(
    private scheduleOffService: ScheduleOffService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let id = route.params['sid']
    
    return this.scheduleOffService.getDetail(id).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/schedule']))
    )
  }
}
